import { UntypedFormGroup } from '@angular/forms';
import { cloneDeep } from 'lodash';

export enum CheckOutFormControls {
    firstName = 'First Name',
    lastName = 'Last Name',
    recipientInfo = 'Recipient Info',
    line1 = 'Address Line 1',
    line2 = 'Address Line 2',
    townOrCity = 'Town/City',
    postCode = 'Postcode',
    province = 'Region',
    country = 'Country',
    email = 'Email',
    company = 'Company',
    phone = 'Home/Business',
    mobile = 'Mobile',
    customerReference = 'Order Reference',
    customerOrderNumber = 'Purchase Order Number',
    customerOtherReference = 'Other Reference',
    comments = 'Delivery Instructions',
    invoiceAddrSwitch = 'Same Invoice Address',
    createAcctSwitch = 'Create New Account',
    password = 'Password'
}

export const setControlError = (formGroup: UntypedFormGroup, controlName: string, errorMessage: string) => {
    if (formGroup.contains(controlName)) {
        const control = formGroup.get(controlName);
        control.setErrors({ 'invalidValue': errorMessage });
    }
};

export const setUnknownFieldErrorMessages = (unknownErrorMessages, fieldName: string, errorMessage: string) => {
    unknownErrorMessages.push(errorMessage.replace('%FIELD_NAME%', fieldName));
};

export const clearErrors = (unknownErrorMessages, group) => {
    unknownErrorMessages = [];
    Object.keys(group.controls).forEach((key) => {
        if (group.get(key).getError('invalidValue') != null) {
            group.get(key).setErrors({ 'invalidValue': null });
        }
    });
};

export const getTransformPhoneAndMobile = (orderInfo) => {
    const info = cloneDeep(orderInfo);
    // patch values from your details page
    const { phone, mobile } = info;
    // if phone is filled and mobile is empty, skip mobile validation or
    if (!!phone && !mobile) {
        info.mobile = null;
    }
    // if mobile is filled and phone is empty, skip phone validation
    if (!!mobile && !phone) {
        info.phone = null;
    }
    // if both phone and mobile are empty
    if (!phone && !mobile) {
        info.phone = null;
        info.mobile = null;
    }

    return info;
};

